<template>
    <!-- <div :class="['page survey',{ off: !pageOn }]"> -->

        <div :class="['page survey',{ off: !pageOn }]"> 
        <!-- <VHeader type="back" @back="pageOn = false;" /> -->
        <!-- <Ham :on="on" @select="hamSelect" /> -->
        <VHeader type="back" @back="back" />
        <div class="page-content">
            <div class="ad-img" v-for="page in ads.filter(ad => selectedCat === true || selectedCat == ad.cat)">
                <div :class="['loyalty-ad-container',{ rotate: page.rotated }]">
                    <!-- <img class="sizer" :src="page.background"/> 
                    <div class="front-box"> -->
                    <div class="front-box" style="position: relative;">
                        <img class="loyalty-ad" :src="pendingSrc" style="position: relative;opacity:0" />
                        <img class="loyalty-ad" :src="page.background" @load="loadedPage($event)" style="position: relative" />
                        <div class="btns" :style="btnsStyle">
                            <div @click="btnClick(page,btn,$event)" @touchstart="btnTouch(page,btn)" v-for="btn in page.btns.filter(b => !b.reverse)" :class="['btn',{ selected: btn.selected },'type-'+btn.content.action]" :style="btn.content.style+';font-size:28px;display:flex;align-items:center;justify-content:space-around;'+( page.styleButton ? (';background-color:'+campaign.buttonColor+';color:'+campaign.buttonFontColor) : '')">
                                <a v-if="btn.content.type == 'phone'" :href="'tel:'+btn.content.value"></a>
                                <img v-if="btn.type == 'gif'" :src="btn.content.gif" :style="btn.content.style" />
                                <video :id="btn.code" v-if="btn.type == 'video'"  :src="btn.content.mov"  controls="true" width="100%" height="100%"></video>
                            </div>
                        </div>
                    </div>
                    <div class="back-box">
                        <img class="loyalty-ad" :src="page.backFaceImage" />
                        <div class="btns" :style="btnsStyle">
                            <div @click="btnClick(page,btn)" v-for="btn in page.btns.filter(b => b.reverse)" :class="['btn',{ selected: btn.selected },'type-'+btn.content.action]" :style="btn.content.style+';font-size:28px;display:flex;align-items:center;justify-content:space-around;'+( page.styleButton ? (';background-color:'+campaign.buttonColor+';color:'+campaign.buttonFontColor) : '')">
                                <img class="qr-btn" v-if="btn.type == 'qr'" :src="page.qrImg+'&date='+Date.now()" />
                                <img v-if="btn.type == 'gif'" :src="btn.content.gif" :style="btn.content.style" />
                                <video :id="btn.code" v-if="btn.type == 'video'"  :src="btn.content.mov"  controls="true" width="100%" height="100%"></video>
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations } from 'vuex'
import WebSoc from '@/utils/WebSoc.js'
import Ham from '@/components/Ham.vue'

export default {
    name: 'survey',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Ham
    },
    computed: {
        survey () { return this.$store.state.survey },
        query () { return this.$store.state.query },
        Query () { return this.$store.state.Query },
        iss () { return this.$store.state.iss },
        customer_id () { return this.$store.state.auth._id },
        customerName () { return this.$store.state.name },
        client_id () { return this.$store.state.client_id },
        customerID () { return this.$store.state.auth.id },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor },
        ads () { return this.$store.state.ads },
        adCats () { return this.$store.state.adCats },
        selectedCat () { return this.$store.state.selectedCat }
    },
    data () {
        return {
            btnsStyle: '',
            date: Date.now(),
            pendingSrc: 'data:image/jpeg;base64,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'
        }
    },
    mounted () {
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.btnsStyle = 'transform: scale('+(width / 414)+')';
        /*
        WebSoc.SEND({ t: 'getAds', data: { client_id: this.client_id, customer_id: this.customer_id, customerID: this.customerID }},resp => {
            if ( !resp.ads ) return;
            if ( resp.ads.length == 0 ) return console.log('got nothing !!');
            resp.ads.forEach(ad => ad.qr && ( ad.qrImg = '' ));
            var adCats = this.adCats;
            var cats = resp.ads.map(ad => ad.cat).filter(c => c).filter((c,i,arr) => arr.indexOf(c) == i).sort((a,b) => adCats.indexOf(a) < adCats.indexOf(b) ? -1 : 1);
            if ( cats.length < 2 ) {
                this.selectedCat = cats[0] || true
            } else {
                this.selectedCat = false
            }
            this.cats = cats;
            this.setValue({ k: 'ads', v: resp.ads });
        })
        */
    },
    methods: {
        loadedPage ( e ) {
            var pending = e.target.previousElementSibling;
                pending && pending.parentElement.removeChild(pending);
        },
        back () {
            this.pageOn = false;
        },
        btnTouch ( page, btn ) {
            //console.log('btnTouch page',page);
            //console.log('btnTouch btn',btn);
        },
        btnClick ( page, btn, e ) {
            
            var action = btn.content.action;

            WebSoc.SEND({ t: 'recordClick', data: { coupon_id: page.coupon_id, rotated: page.rotated, campaign_id: page.campaign_id, client_id: this.client_id, survey_id: this.survey._id, iss: this.iss, name: this.customerName, customer_id: this.customer_id, ad_id: page.ad_id, pageCode: page.code, btnCode: btn.code, type: btn.type }});
            
            var Service = {
                rotate: ( page, btn ) => { 

                    var qr = page.btns.find(b => b.type == 'qr');
                    //console.log('page.btns',JSON.parse(JSON.stringify(page.btns)));
                    //console.log('qr',qr);

                    //if ( !qr ) return;

                    var data = { survey_id: this.survey._id, customer_id: this.customer_id, ad_id: page.ad_id, pageCode: page.code, QrBtnCode: qr && qr.code, iss: this.iss }
                    
                    if ( !page.rotated ) {

                        var date = Date.now();

                        //console.log('page',JSON.parse(JSON.stringify(page)));
                        //console.log('btn',JSON.parse(JSON.stringify(btn)));
                        /*
                        var survey = this.survey;
                        var query = this.query;
                        var date = Date.now();
                        var customerID = this.customerID;
                        var iss = this.iss;
                        */

                        var iss = page.iss;
                        var customerID = this.customerID;
                        var surveyID = page.campaignId;
                        var customer_id = this.customer_id;
                        var client_id = page.client_id;
                        var survey_id = page.campaign_id;
                        var coupon_id = page.coupon_id;
                        /*
                        console.log({
                            iss,
                            customerID,
                            surveyID,
                            survey_id,
                            customer_id,
                            client_id
                        });
                        */
                        //page.qrImg = 'https://api.survey-vip.com/qr?id='+encodeURIComponent('https://loyalty-vip.com/redeem?s='+surveyID+'&c='+customerID+'&p='+page.code+'&i='+iss+'&b='+client_id+'&d='+date);

                        if ( window.webpackHotUpdate ) {
                            var src = 'http://localhost:5555/qr?id='
                        } else {
                            var src = 'https://api-v2.memberstar.club/qr?id='
                        }

                        //var src = 'https://api-v2.memberstar.club/qr?id=';

                        page.qrImg = src+encodeURIComponent('https://scanner.memberstar.club/redeem?x='+page.couponId); //+'&redeemed=true';

                        var data = {
                            pageCode: page.code,
                            iss,
                            customerID,
                            surveyID,
                            survey_id,
                            customer_id,
                            client_id,
                            coupon_id,
                            couponId: page.couponId
                        };
                        
                        if ( qr ) {
                            console.log('send viewedCoupon',data);
                            WebSoc.SEND({ t: 'viewedCoupon', data },resp => {
                                console.log('viewedCoupon resp',resp)
                                if ( resp.coupon_id ) page.coupon_id = resp.coupon_id;
                                if ( resp.redeemed ) {
                                    page.qrImg += '&redeemed='+Date.now();
                                    this.$forceUpdate();
                                };
                            });
                        }
                    } else {
                        
                        data.sent_id = page.sent_id;
                        data.adIndex = page.adIndex;

                        WebSoc.SEND({ t: 'viewedCouponStop', data: { coupon_id: page.coupon_id } },resp => {
                            console.log('stopped view coupon',resp);
                        });
                    }

                    this.setKeyValue({ item: page, k: 'rotated', v: !page.rotated }) 
                },
                terms: ( page, btn ) => this.$emit('showSurveyTerms',btn.terms_id),
                link: ( page, btn ) => {
                    var link = btn.content.value;
                    if ( btn.type == 'link' ) {
                        window.open(link.indexOf('http') == -1 ? 'http://'+link : link);
                    }
                    if ( btn.type == 'phone' ) {
                        console.log('phone..')
                    }
                }
            }
            if ( typeof Service[action] == 'function' ) return Service[action](page, btn);
            console.log('what with',action);
            console.log(Object.keys(Service));

        },
        ...mapMutations([
            'pushPage',
            'setKeyValue',
            'setValue'
        ])
    }
}

</script>

<style lang="scss">
.page.survey {
    .page-content {
        background-color: white;
        height: calc(100% - 40px);
        overflow-x: hidden;
        .ad-img:last-child {
            .loyalty-ad-container {
                margin-bottom: 200px;
            }
        }
    }
}    
div.loyalty-ad-container {
    position: relative;
    transition: transform 1s;
    -webkit-perspective: 1000;
    transform-style: preserve-3d;
    perspective: 1000;
    -webkit-transform:translate3d(0,0,0);
    float: left;
    width: calc(100% - 10px);
    margin: 5px 0px 0px 5px;
    img.sizer {
        width: 100%;
        margin: 0px;
        z-index: -1;
        opacity: 0;
    }
    .front-box,.back-box {
        float: left;
        opacity: 1;
        position: absolute;
        width: 100%;
        margin: 0px;
        top: 0px;
        left: 0px;
        backface-visibility: hidden;
        -webkit-transform:translate3d(0,0,0);
        transform-style: preserve-3d;
        perspective: 1000;
    }
    .front-box {
        z-index: 2;
    }
    .back-box {
        z-index: 1;
        transform: rotateY(180deg);
        position: absolute;
        left: 0px;
    }
    &.rotate {
        transform: rotateY(180deg);
    }
    img.loyalty-ad {
        width: 100%;
        position: absolute;
        box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.6);
    }
    .btns {
        position: absolute;
        top: 0px;
        left: 0px;
        transform-origin: 0px 0px;
        .btn { position: absolute; background-color: rgba(200,0,200,0); &:active { transform: translate(0px,0px) } }
        .type-qr img { width: 100%; }
        .type-link a { position: absolute; width: 100%; height: 100%; }
    }
}
</style>